export const PT_DIOCESES = [
  "Patriarcado de Lisboa", "Arquidiocese de Braga", "Arquidiocese de Évora",
  "Diocese de Angra (Açores)", "Diocese de Aveiro", "Diocese de Beja",
  "Diocese de Bragança-Miranda", "Diocese de Coimbra", "Diocese da Guarda",
  "Diocese de Lamego", "Diocese de Leiria-Fátima", "Diocese de Portalegre-Castelo Branco",
  "Diocese do Porto", "Diocese de Santarém", "Diocese de Setúbal",
  "Diocese de Viana do Castelo", "Diocese de Vila Real", "Diocese de Viseu",
  "Diocese do Algarve (Faro)", "Diocese do Funchal (Madeira)", "Ordinariato Castrense",
  "Outra / Fora de Portugal",
];
